import { BasicEnumerable } from "../BasicEnumerable.js";
export const each = (source, action) => {
    function* generator() {
        for (const value of source) {
            action(value);
            yield value;
        }
    }
    return new BasicEnumerable(generator);
};
